import React from 'react';
import * as S from './style';
import InputOnlyNumber, {
  Props as InputOnlyNumberProps,
} from 'components/atoms/InputOnlyNumber';
import { Label } from 'components';
import {
  SUB_LABEL_CLEANING_FIRST,
  SUB_LABEL_CLEANING_SECOND,
  SUB_LABEL_CLEANING_EXAMPLE_FIRST,
  SUB_LABEL_CLEANING_EXAMPLE_SECOND,
} from 'commons/ZimssaString';

export interface Props {
  sizeTo: InputOnlyNumberProps;
  fixedPrice: InputOnlyNumberProps;
  unitPrice: InputOnlyNumberProps;
  caption?: React.ReactNode | null;
}

function CleaningPrice({ caption, ...props }: Props): React.ReactElement {
  return (
    <S.ContentWrpper>
      <S.RowWrapper>
        <S.SizeWrapper>
          <InputOnlyNumber disabled {...props.sizeTo} maxLength={3} />
        </S.SizeWrapper>
        <S.LabelWrapper>
          <Label
            color={'gray_opacity_800'}
            fontStyle={'subtitle'}
            contents={SUB_LABEL_CLEANING_FIRST}
          />
        </S.LabelWrapper>
        <S.PriceWrapper>
          <InputOnlyNumber
            {...props.fixedPrice}
            thousandSeparator={true}
            maxLength={7}
          />
        </S.PriceWrapper>
      </S.RowWrapper>
      <S.RowWrapper>
        <S.SizeWrapper>
          <InputOnlyNumber disabled {...props.sizeTo} maxLength={3} />
        </S.SizeWrapper>
        <S.LabelWrapper>
          <Label
            color={'gray_opacity_800'}
            fontStyle={'subtitle'}
            contents={SUB_LABEL_CLEANING_SECOND}
          />
        </S.LabelWrapper>
        <S.PriceWrapper>
          <InputOnlyNumber
            {...props.unitPrice}
            thousandSeparator={true}
            maxLength={6}
          />
        </S.PriceWrapper>
      </S.RowWrapper>
      <S.InfoWrapper>
        <Label
          color={'gray_opacity_600'}
          fontStyle={'subtitle'}
          contents={'예)'}
        />
        <S.CommentWrapper>
          <Label
            color={'gray_opacity_600'}
            fontStyle={'subtitle'}
            contents={SUB_LABEL_CLEANING_EXAMPLE_FIRST}
          />
          <Label
            color={'gray_opacity_600'}
            fontStyle={'subtitle'}
            contents={SUB_LABEL_CLEANING_EXAMPLE_SECOND}
          />
        </S.CommentWrapper>
      </S.InfoWrapper>
      {caption ? <S.CaptionWrapper>{caption}</S.CaptionWrapper> : null}
    </S.ContentWrpper>
  );
}
export default CleaningPrice;
